import React, { FC } from 'react'

import PubSub from 'pubsub-js'
import { Notification, useAuthState, useLogin, useNotify, useRedirect } from 'react-admin'
import { Navigate } from 'react-router'
// import { ThemeProvider } from '@mui/styles';
// import { createMuiTheme, makeStyles } from '@mui/material/styles';

import Auth from 'auth'
import { generateFetchRequest } from 'clients/fetch'
import { AppLoadingView } from 'dash/AppLoadingView'
import AppState from 'shared/app_state'
import { Account, User } from 'shared/types'


const DashLoginView: FC = () => {
  const login = useLogin()
  const notify = useNotify()
  const redirect = useRedirect()
  const { isLoading: authStateLoading, authenticated } = useAuthState()

  const onLoginSuccess = () => {
    PubSub.publish('user/login')

    notify('Login Successful', { type: 'success' })

    if (AppState.getLastPage()) redirect(AppState.getLastPage())
  }

  const onRequestPasswordReset = async ({
    onFailure,
    onSuccess,
    params,
  }: {
    onFailure: (msg: string) => void
    onSuccess: (msg: string) => void
    params: { [key: string]: string }
  }) => {
    const request = generateFetchRequest({
      body: JSON.stringify({ user: params }),
      method: 'POST',
      path: 'users/password',
    })

    try {
      const response = await fetch(request)
      const data = await response.json()

      if (response.status != 200) {
        throw new Error(data.errors)
      }

      onSuccess('We have sent password reset instructions to your email address.')
    } catch (fetchError) {
      if (fetchError && fetchError.message) onFailure(fetchError.message)
      else onFailure('There was an error sending your password reset email.')
    }
  }

  const onPasswordReset = async ({
    onFailure,
    params,
  }: {
    onFailure: (msg: string) => void
    params: {
      password: string
      passwordResetToken: string
    }
  }) => {
    const { password, passwordResetToken } = params
    const request = generateFetchRequest({
      body: JSON.stringify({ user: { reset_password_token: passwordResetToken, password } }),
      method: 'PUT',
      path: 'users/password',
    })

    try {
      const response = await fetch(request)
      const data = await response.json()

      if (response.status != 200) {
        throw new Error(data.errors)
      }

      const { resource: user }: { resource: User } = data

      PubSub.publish('user/password-reset')

      notify('Login Successful', { type: 'success' })

      await AppState.setIdentity({ user })

      redirect('/')
    } catch (e) {
      if (e.message == 'Invalid credentials.') onFailure('Incorrect email or password.')
      else onFailure(e.message)
    }
  }

  const onSignupSuccess = async ({ account, user }: { account: Account; user: User }, accountCreation: boolean) => {
    PubSub.publish('user/signup')

    await AppState.setIdentity({ account, user })

    if (AppState.getLastPage()) redirect(AppState.getLastPage())
    else redirect(`/account/${account.id}/services/form?welcome=true${accountCreation ? '&initial=true' : ''}`)
  }

  if (authStateLoading) return AppLoadingView
  else if (authenticated) return <Navigate to="/" />

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        margin: 20,
      }}
    >
      <div>
        <Auth.Wizard
          onLogin={login}
          onLoginSuccess={onLoginSuccess}
          onPasswordReset={onPasswordReset}
          onRequestPasswordReset={onRequestPasswordReset}
          onSignupSuccess={onSignupSuccess}
        />
        <Notification />
      </div>
    </div>
  )
}

export default DashLoginView

// export const lightTheme = {
//   palette: {
//     secondary: {
//       light: '#5f5fc4',
//       main: '#283593',
//       dark: '#001064',
//       contrastText: '#fff',
//     },
//   },
//   overrides: {
//     MuiFilledInput: {
//       root: {
//         backgroundColor: 'rgba(0, 0, 0, 0.04)',
//         '&$disabled': {
//           backgroundColor: 'rgba(0, 0, 0, 0.04)',
//         },
//       },
//     },
//   },
// };

// const useStyles = makeStyles((theme) => ({
//   main: {
//     display: 'flex',
//     flexDirection: 'column',
//     minHeight: '100vh',
//     alignItems: 'center',
//     justifyContent: 'flex-start',
//     'backdrop-filter': 'blur(20px)',
//     backgroundImage:
//       'url(https://images.unsplash.com/photo-1592191136579-27d0d2d44e86?ixlib=rb-1.2.1&ixid=MXwxMjA3fDB8MHxzZWFyY2h8MjN8fHB1cnBsZXxlbnwwfHwwfA%3D%3D&auto=format&fit=crop&w=800&q=60)',
//     // backgroundPosition: 'center',
//     backgroundRepeat: 'no-repeat',
//     backgroundSize: 'cover',
//     //   filter: 'blur(5px)',
//   },
//   // bg: {
//   //   height: '100%',
//   //   backgroundImage:
//   //     'url(https://images.unsplash.com/photo-1573614999645-e5f0f16ec15d?ixlib=rb-1.2.1&ixid=MXwxMjA3fDB8MHxzZWFyY2h8N3x8cHVycGxlfGVufDB8fDB8&auto=format&fit=crop&w=80&q=80)',
//   //   backgroundPosition: 'center',
//   //   backgroundRepeat: 'no-repeat',
//   //   backgroundSize: 'cover',
//   //   filter: 'blur(5px)',
//   // },
//   card: {
//     minWidth: 300,
//     marginTop: '6em',
//   },
//   avatar: {
//     margin: '1em',
//     display: 'flex',
//     justifyContent: 'center',
//   },
//   logo: {
//     width: '140px',
//   },
//   hint: {
//     marginTop: '1em',
//     display: 'flex',
//     justifyContent: 'center',
//     color: theme.palette.grey[500],
//   },
//   formError: {
//     marginTop: '1em',
//     display: 'flex',
//     justifyContent: 'center',
//     color: 'red',
//   },
//   form: {
//     padding: '0 1em 1em 1em',
//   },
//   input: {
//     marginTop: '1em',
//   },
//   actions: {
//     padding: '0 1em 1em 1em',
//   },
// }));

// const LoginView: React.FC = () => {
//   const classes = useStyles({});

//   return (
//     <ThemeProvider theme={createMuiTheme(lightTheme)}>
//       <LoginForm classes={classes} />
//     </ThemeProvider>
//   );
// };
